import apollo from '@/graphql'

import RetailerDetailsQuery from '@/graphql/retailer/RetailerDetailsQuery.gql'
import SaveRetailerDetails from '@/graphql/retailer/SaveRetailerDetails.gql'
import UploadRetailerLogo from '@/graphql/retailer/UploadRetailerLogo.gql'

// initial state
const state = {
  editableRetailerFields: {
    isAtmosphereEnabled: true,
    isFillerEnabled: true,
  },
  retailerDetails: {},
}

// getters
const getters = {
  editableRetailerFields: st => st.editableRetailerFields,
  retailerDetails: st => st.retailerDetails,
}

// mutations
const mutations = {
  createRetailerDetails() {
    state.editableRetailerFields = {
      companyType: 'retailer',
      isAtmosphereEnabled: true,
      isFillerEnabled: true,
    }
    state.retailerDetails = { name: 'New Retailer', wholesaler: {} }
  },

  setEditableRetailerFields(st, retailerDetails) {
    state.editableRetailerFields = {
      address: retailerDetails.address,
      id: retailerDetails.id,
      isAtmosphereEnabled: retailerDetails.isAtmosphereEnabled,
      isFillerEnabled: retailerDetails.isFillerEnabled,
      isSendSCReports: retailerDetails.isSendSCReports,
      isSpanishEmails: retailerDetails.isSpanishEmails,
      name: retailerDetails.name,
      phone: retailerDetails.phone,
      scFrequency: retailerDetails.scFrequency,
      wholesalersId: Object.assign({}, retailerDetails.wholesaler).id || null,
    }
  },

  setRetailerDetails(st, retailerDetails) {
    state.retailerDetails = retailerDetails
  },

  updateRetailerFields(st, fields) {
    Object.assign(state.editableRetailerFields, fields)
  },
}

// actions
const actions = {
  loadRetailerDetails({ commit }, { id }) {
    apollo.defaultClient
      .watchQuery({
        fetchPolicy: 'network-only',
        query: RetailerDetailsQuery,
        variables: { id: +id },
      })
      .subscribe(({ data: { retailerDetails } }) => {
        commit('setRetailerDetails', retailerDetails)
        commit('setEditableRetailerFields', retailerDetails)
      })
  },

  saveRetailerDetails(context, { $message, $router }) {
    apollo.defaultClient
      .mutate({
        mutation: SaveRetailerDetails,
        variables: {
          fields: state.editableRetailerFields,
          lanes: state.lanes,
        },
        refetchQueries: [state.retailerDetails.id].filter(id => id).map(id => ({
          query: RetailerDetailsQuery,
          variables: { id },
        })),
      })
      .then(({ data: { saveCompanyDetails: { id } } }) => {
        $message({ message: 'Changes saved', type: 'success' })
        $router.push(`/retailer/${id}`)
      })
      .catch((err) => {
        $message.error(err.message)
      })

    state.isEditableRetailerFieldsLoaded = false
  },

  async uploadRetailerLogo(context, { file }) {
    try {
      await apollo.defaultClient.mutate({
        mutation: UploadRetailerLogo,
        variables: { id: state.retailerDetails.id, file },
        refetchQueries: [
          {
            query: RetailerDetailsQuery,
            variables: { id: state.retailerDetails.id },
          },
        ],
      })
    } catch (err) {
      throw new Error(err.graphQLErrors[0].message)
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/retailer/RetailerDetails.js